import { IKeyValue } from 'motw_core/Entity/IKeyValue';

const defaultKeyValue: IKeyValue = {
	id: 0,
	key: '',
	value: '',
	lastmodifiedtime: new Date().toISOString(),
	expiry: 60,
	value_json: ``
};

export function GetDefaultKeyValue(): IKeyValue {
	return defaultKeyValue;
}

export function IsDefaultKeyValue(keyValue: IKeyValue): boolean {
	return (
		keyValue.key === defaultKeyValue.key &&
		keyValue.value === defaultKeyValue.value
	);
}
